import { API } from "@/constants/common";
import { apiClient } from "../client/apiClient";
import { LocationMasterParams } from "./type";

export class CustomerParamsService {
  static instance: CustomerParamsService;

  public static QUERY_KEY = {
    BASE: "customer_params",
    FETCH_ALL: ["customer_params", "fetch_all"],
    LOCATION_MASTER: ["customer_params", "location_master"],
  };

  constructor() {
    if (CustomerParamsService.instance) {
      return CustomerParamsService.instance;
    }
    CustomerParamsService.instance = this;
  }

  async getLocationMaster(params: LocationMasterParams): Promise<any> {
    const data = await apiClient.get(API.CUSTOMER_PARAMS.LOCATION_MASTER, {
      limit: params.limit,
      page: params.page,
      ...(params.search && { search: params.search }),
      ...(params.type && { type: params.type }),
      ...(params.parent_id && { parent_id: params.parent_id.join(",") }),
    });
    return data;
  }
}
